import { ListFilters } from "../ListFilters";

type ProcedureFiltersProps = {
  categories: string[];
  owners: string[];
  selectedCategories: string[];
  selectedOwners: string[];
  onCategoriesChange: (values: string[]) => void;
  onOwnersChange: (values: string[]) => void;
  onReset: () => void;
};

export function ProcedureFilters({
  categories,
  owners,
  selectedCategories,
  selectedOwners,
  onCategoriesChange,
  onOwnersChange,
  onReset,
}: ProcedureFiltersProps) {
  return (
    <ListFilters
      activeFilterCount={selectedCategories.length + selectedOwners.length}
      ariaLabel="Procedure filters"
      facets={[
        {
          key: "category",
          label: "Category",
          options: categories.map((category) => ({
            label: category,
            value: category,
          })),
          value: selectedCategories,
          onChange: onCategoriesChange,
        },
        {
          key: "owner",
          label: "Owner",
          options: owners.map((owner) => ({ label: owner, value: owner })),
          value: selectedOwners,
          onChange: onOwnersChange,
        },
      ]}
      onReset={onReset}
    />
  );
}
